<style lang="scss" scoped>
.profile-contact-wrapper {
  display: flex;
  align-items: center;
  flex-flow: column;
}

.profile-picture-wrapper {
  max-width: 200px;
  margin-bottom: 1rem;
}

.profile-picture {
  max-width: 100%;
}

.close-button {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.5rem;
  transition: color 0.3s;

  &:hover {
    cursor: pointer;
    color: $gray-600;
  }
}

.public-profile-modal::v-deep .v--modal-box {
  top: 40px !important;
  max-height: calc(100vh - 60px);
  border-radius: 5px;
  overflow-y: auto;
}

.profile-contact-text {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.text-list {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.login-form {
  display: flex;
  flex-flow: column;

  input {
    margin-bottom: 1rem;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
  .mt-3 {
    margin-bottom: 40px;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
  .mt-3 {
    margin-bottom: 80px;
  }
}

@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) {
  .mt-3 {
    margin-bottom: 60px;
  }
}

@media (min-width: 480px) {
  .profile-contact-wrapper {
    flex-flow: row;
  }

  .profile-picture-wrapper {
    margin-bottom: 0;
    margin-right: 2rem;
  }

  .text-list {
    display: flex;
    flex-flow: row;

    & > * {
      margin-right: 0.4rem;
    }
  }
  .login-form {
    flex-flow: row;

    input {
      margin-bottom: 0;
      margin-right: 1rem;
    }
  }
}
</style>

<template>
  <modal
    class="public-profile-modal"
    name="public-profile-modal"
    :maxWidth="900"
    width="90%"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    style="overflow: hidden"
  >
    <div class="p-3">
      <i
        @click="$modal.hide('public-profile-modal')"
        class="fas fa-times close-button"
      ></i>
      <div class="profile-contact-wrapper">
        <div class="profile-picture-wrapper">
          <img
            class="rounded profile-picture"
            :src="profile.primary_image.url"
          />
        </div>
        <div>
          <p class="profile-contact-text">
            Du willst mit <strong>{{ profile.name }}</strong> Kontakt aufnehmen?
          </p>
          <p class="text-list">
            <span>{{ imageCountText }} •</span>
            <span>{{ audioCountText }} •</span>
            <span>{{ eroticCountText }}</span>
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center my-4">
        <hr class="w-50" />
        <span class="mx-3 text-muted">entweder</span>
        <hr class="w-50" />
      </div>
      <div class="text-center">
        <h2 class="mb-3">Du willst kostenlos Mitglied werden?</h2>
        <p class="text-list justify-content-center">
          <span>Keine Abos •</span> <span>Keine versteckten Kosten •</span>
          <span>Profil jederzeit löschbar</span>
        </p>
        <signup noBackground />
      </div>
      <div class="d-flex align-items-center my-4">
        <hr class="w-50" />
        <span class="mx-3 text-muted">oder</span>
        <hr class="w-50" />
      </div>
      <div class="text-center">
        <h2 class="mb-3">Du bist bereits Mitglied?</h2>
        <a href="/login" class="d-inline-block btn btn-primary btn-lg mt-3"
          >Einloggen</a
        >
      </div>
    </div>
  </modal>
</template>

<script>
import { CSRFToken } from "@/communication";

export default {
  props: {
    profile: {
      required: true,
      type: Object
    }
  },
  computed: {
    csrfToken() {
      return CSRFToken();
    },
    images() {
      return this.profile.media
        .filter(media => media.is_image)
        .filter(media => media.confirmed != null);
    },
    audio() {
      return this.profile.media
        .filter(media => media.is_audio)
        .filter(media => media.confirmed != null);
    },
    eroticMedia() {
      return this.profile.media
        .filter(media => media.is_erotic)
        .filter(media => media.confirmed != null);
    },
    imageCountText() {
      if (this.images.length === 1) {
        return "1 Bild";
      }

      return this.images.length + " Bilder";
    },
    audioCountText() {
      if (this.audio.length === 1) {
        return "1 Sprachnachricht";
      }

      return this.audio.length + " Sprachnachrichten";
    },
    eroticCountText() {
      if (this.eroticMedia.length === 1) {
        return "1 erotischer Inhalt";
      }

      return this.eroticMedia.length + " erotische Inhalte";
    }
  },
  mounted() {
    this.$store.dispatch("publicProfileModal/startTimeout", this.$modal);
  }
};
</script>
